import { Row as RowBase } from 'antd';
import { RowProps } from 'antd/lib/row';
import React from 'react';

export interface IRowProp extends RowProps {
  children?: React.ReactNode;
}

const Row: React.FC<IRowProp> = ({ children, ...props }) => {
  return <RowBase {...props}>{children}</RowBase>;
};

export default Row;
